/* eslint-disable react/jsx-no-undef */
import { Page, useInjectSaga } from '@elliemae/pui-app-sdk';
import { identifyLogRocketUser } from '@frontend/logrocket';
import { useEffect, useRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '../view/layout';

// import { LoanView } from '../view/loan-view/loadable';
import { onSessionEvent } from '../sideeffect/session';
// import { DataPage1 } from '../view/data-page-1/loadable';
import LoadableClientConfiguration from '../view/client-configuration/loadable';
// eslint-disable-next-line prettier/prettier
import { ClientFlags } from '../view/ClientFlags/loadable';
import ClientDefinition from '../view/clients/clientDefinition';
import { Clients } from '../view/clients/loadable';
import { LoadableDeepLink } from '../view/deep-link/loadable';
import LoadableGlobalConfiguration from '../view/global-configuration/loadable';
import LoadableInvestorConfiguration from '../view/investor-configuration/loadable'; // Adjusted path
import ClientInvestorRelationship from '../view/investor-relationships/clientInvestorRelationship';
import ClientInvestorRelationshipVersions from '../view/investor-relationships/clientInvestorRelationshipversions';
import { InvestorRelationships } from '../view/investor-relationships/loadable';
import {
  LoadablePipelineClientRunDetailsPage,
  LoadablePipelineConfiguration,
  LoadablePipelineRunDetailsPage,
} from '../view/pipeline/loadable';
import { PricingSearchLayout } from '../view/pricing-search/layout/index';
import { LoadableRulesBuilder } from '../view/pricing-search/rule-builder/loadable';
import { LoadableRulesEditor } from '../view/pricing-search/rule-builder/rule-editor-loadable';
import LoadableSchemaView from '../view/pricing-search/schema-view/loadable';
import { ProgramFlags } from '../view/program-flags/loadable';
import ConditionVersions from '../view/programs/conditionVersions';
import GuidelineVersions from '../view/programs/guidelineVersions';
import { Programs } from '../view/programs/loadable';
import ProgramDefinition from '../view/programs/programDefinition';
import ProgramVersions from '../view/programs/programVersions';
import RatioVersions from '../view/programs/ratioVersions';
import { RateData } from '../view/rate-data/loadable';
import { Matrix } from '../view/Matrix/loadable';
import { MDM } from '../view/mdm/loadable';
import DeepLinkGuard from '../view/mdm/deepLinkGuard';
import {
  EditPage,
  RateDefinitions,
  RateDefinitionsEdit,
} from '../view/RateDefinitions/loadable';
import LoadableAttributionCategoriesView from '../view/attributionCategories/loadable';

const key = 'session';

export const AppRoutes = () => {
  useInjectSaga({ key, saga: onSessionEvent });

  const hasIdentified = useRef(false);
  useEffect(() => {
    if (hasIdentified.current) return;
    const clientId = sessionStorage.getItem('clientID') ?? 'Unknown Client ID';
    const clientName =
      sessionStorage.getItem('clientName') ?? 'Unknown Client Name';
    identifyLogRocketUser({ name: `PPE | ${clientId} - ${clientName}` });
    hasIdentified.current = true;
  }, []);

  return (
    <Routes>
      <Route
        path="/deep-link"
        element={
          <Page pageTitle="ICE PPE">
            <LoadableDeepLink />
          </Page>
        }
      ></Route>
      <Route path="/pricing-search" element={<PricingSearchLayout />}>
        <Route
          path="/pricing-search"
          element={<Navigate to="/pricing-search/schema" />}
        />
        <Route
          path="/pricing-search/schema"
          element={
            <Page pageTitle="Pricing Search">
              <LoadableSchemaView />
            </Page>
          }
        ></Route>
        <Route
          path="/pricing-search/conditions"
          element={
            <Page pageTitle="Manage Conditions">
              <LoadableRulesBuilder />
            </Page>
          }
        ></Route>
        <Route
          path="/pricing-search/conditions/create"
          element={
            <Page pageTitle="Create Condition">
              <LoadableRulesEditor />
            </Page>
          }
        ></Route>
        <Route
          path="/pricing-search/conditions/:ruleId/edit"
          element={
            <Page pageTitle="Edit Condition">
              <LoadableRulesEditor />
            </Page>
          }
        ></Route>
      </Route>
      <Route
        path="/attribution-categories"
        element={
          <Page pageTitle="Attribution Categories">
            <LoadableAttributionCategoriesView />
          </Page>
        }
      ></Route>
      <Route
        path="/mdm"
        element={
          <Page pageTitle="MDM">
            <DeepLinkGuard>
              <MDM />
            </DeepLinkGuard>
          </Page>
        }
      ></Route>
      <Route
        path="/mdm/:lender/:matrixId/:matrixVersionId/:mode"
        element={
          <Page pageTitle="MDM">
            <DeepLinkGuard>
              <MDM />
            </DeepLinkGuard>
          </Page>
        }
      ></Route>
      <Route path="/" element={<Layout />}>
        <Route
          path="investor-configuration"
          element={
            <Page pageTitle="Investor Configuration">
              <LoadableInvestorConfiguration />
            </Page>
          }
        />

        <Route
          path="global-configuration"
          element={
            <Page pageTitle="Global Configuration">
              <LoadableGlobalConfiguration />
            </Page>
          }
        />
        <Route
          path="rate-sheet-configuration"
          element={
            <Page pageTitle="Rate Sheet Configuration">
              <LoadableClientConfiguration />
            </Page>
          }
        />
        <Route
          path="pipeline"
          element={
            <Page pageTitle="Pipeline Configuration">
              <LoadablePipelineConfiguration />
            </Page>
          }
        />
        <Route
          path="pipeline/runDetailsPage/:uuid"
          element={
            <Page pageTitle="RunDetailsPage">
              <LoadablePipelineRunDetailsPage />
            </Page>
          }
        />
        <Route
          path="pipeline/client-runs/:uuid"
          element={
            <Page pageTitle="RunDetailsPage">
              <LoadablePipelineClientRunDetailsPage />
            </Page>
          }
        />
        <Route
          path="rate-definitions"
          element={
            <Page pageTitle="RateDefinitions">
              <RateDefinitions />
            </Page>
          }
        />
        <Route
          path="/clients"
          element={
            <Page pageTitle="clients">
              <Clients />
            </Page>
          }
        />
        <Route
          path="/clients/:id"
          element={
            <Page pageTitle="Client Definition">
              <ClientDefinition />
            </Page>
          }
        />
        <Route
          path="/rate-definitions/:pageAction/:id"
          element={
            <Page pageTitle="Edit Rate Definition">
              <EditPage />
            </Page>
          }
        />
        <Route
          path="client-flags"
          element={
            <Page pageTitle="Client Flags">
              <ClientFlags />
            </Page>
          }
        />
        <Route
          path="/rate-definitions/:pageAction/rate/:lenderId/:rateVersionId/:rateDefinitionId/:action"
          element={
            <Page pageTitle="Rate Definition">
              <RateDefinitionsEdit />
            </Page>
          }
        />
        <Route
          path="program-flags"
          element={
            <Page pageTitle="Program Flags">
              <ProgramFlags />
            </Page>
          }
        />
        <Route
          path="rate-data"
          element={
            <Page pageTitle="Rate Data">
              <RateData />
            </Page>
          }
        />
        <Route
          path="programs"
          element={
            <Page pageTitle="programs">
              <Programs />
            </Page>
          }
        />
        <Route
          path="/programs/:id"
          element={
            <Page pageTitle="Program Definition">
              <ProgramDefinition />
            </Page>
          }
        />
        <Route
          path="/programs/:id/versions"
          element={
            <Page pageTitle="Program Versions">
              <ProgramVersions />
            </Page>
          }
        />
        <Route
          path="/programs/:id/conditions"
          element={
            <Page pageTitle="Condition Versions">
              <ConditionVersions />
            </Page>
          }
        />
        <Route
          path="/programs/:id/guidelines"
          element={
            <Page pageTitle="Guideline Versions">
              <GuidelineVersions />
            </Page>
          }
        />
        <Route
          path="/programs/:id/ratios"
          element={
            <Page pageTitle="Ratio Versions">
              <RatioVersions />
            </Page>
          }
        />
        <Route
          path="investor-relationships"
          element={
            <Page pageTitle="Investor Relationships">
              <InvestorRelationships />
            </Page>
          }
        />
        <Route
          path="/investor-relationships/:clientLenderId"
          element={
            <Page pageTitle="Investor Relationship">
              <ClientInvestorRelationship />
            </Page>
          }
        />
        <Route
          path="/investor-relationships/:clientLenderId/versions"
          element={
            <Page pageTitle="Investor Relationship versions">
              <ClientInvestorRelationshipVersions />
            </Page>
          }
        />

        {/* <Route
          path="admin"
          element={
            <RequireAuth>
              <Page pageTitle="Admin">
                <LoadableLoginForm />
              </Page>
            </RequireAuth>
          }
        /> */}
        <Route
          path="matrix"
          element={
            <Page pageTitle="Matrix (Demo)">
              <Matrix />
            </Page>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};
